import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Table, Container, Row, Col, Card, InputGroup, Alert, Badge } from 'react-bootstrap';
import { FaPlus, FaTrash, FaSearch, FaUser, FaProjectDiagram, FaUserTie, FaBuilding } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import pythonApiClient from '../../services/api/pythonBaseApi';

const MantenimientoUsuariosProyectos = () => {
  const [asignaciones, setAsignaciones] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [proyectos, setProyectos] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentAssignment, setCurrentAssignment] = useState({
    id_user: '',
    id_proyecto: ''
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [filterBy, setFilterBy] = useState('all'); // all, usuario, proyecto

  useEffect(() => {
    fetchAsignaciones();
    fetchUsuarios();
    fetchProyectos();
  }, []);

  const fetchAsignaciones = async () => {
    setLoading(true);
    try {
      const response = await pythonApiClient.get('/mantenimientos/usuarios-proyectos');
      setAsignaciones(response.data || []);
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.response?.data?.detail || 'Error al cargar asignaciones');
    } finally {
      setLoading(false);
    }
  };

  const fetchUsuarios = async () => {
    try {
      const response = await pythonApiClient.get('/mantenimientos/usuarios-proyectos-data/usuarios');
      setUsuarios(response.data || []);
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.response?.data?.detail || 'Error al cargar usuarios');
    }
  };

  const fetchProyectos = async () => {
    try {
      const response = await pythonApiClient.get('/mantenimientos/usuarios-proyectos-data/proyectos');
      setProyectos(response.data || []);
    } catch (error) {
      console.error('Error:', error);
      toast.error(error.response?.data?.detail || 'Error al cargar proyectos');
    }
  };

  const handleShow = () => {
    setCurrentAssignment({
      id_user: '',
      id_proyecto: ''
    });
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setCurrentAssignment({
      id_user: '',
      id_proyecto: ''
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentAssignment(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!currentAssignment.id_user || !currentAssignment.id_proyecto) {
      toast.error('Por favor seleccione un usuario y un proyecto');
      return;
    }

    setLoading(true);
    try {
      const response = await pythonApiClient.post('/mantenimientos/usuarios-proyectos', {
        id_user: parseInt(currentAssignment.id_user),
        id_proyecto: parseInt(currentAssignment.id_proyecto)
      });

      toast.success('Asignación creada exitosamente');
      handleClose();
      fetchAsignaciones();
    } catch (error) {
      console.error('Error:', error);
      const errorMessage = error.response?.data?.detail || error.response?.data?.message || 'Error al crear asignación';
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (asignacionId) => {
    if (window.confirm('¿Está seguro de que desea eliminar esta asignación?')) {
      setLoading(true);
      try {
        await pythonApiClient.delete(`/mantenimientos/usuarios-proyectos/${asignacionId}`);
        toast.success('Asignación eliminada exitosamente');
        fetchAsignaciones();
      } catch (error) {
        console.error('Error:', error);
        const errorMessage = error.response?.data?.detail || error.response?.data?.message || 'Error al eliminar asignación';
        toast.error(errorMessage);
      } finally {
        setLoading(false);
      }
    }
  };

  const filteredAsignaciones = asignaciones.filter(asignacion => {
    const matchesSearch = 
      asignacion.usuario_nombre?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      asignacion.usuario_email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      asignacion.proyecto_nombre?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      asignacion.usuario_documento?.toString().includes(searchTerm);

    if (filterBy === 'all') return matchesSearch;
    
    return matchesSearch;
  });

  // Obtener estadísticas
  const totalAsignaciones = asignaciones.length;
  const usuariosConProyectos = [...new Set(asignaciones.map(a => a.id_user))].length;
  const proyectosConUsuarios = [...new Set(asignaciones.map(a => a.id_proyecto))].length;

  return (
    <Container fluid className="py-4">
      <style>
        {`
          .card-dh {
            border: none;
            border-radius: 1rem;
            box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          }

          .card-header-dh {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            border-radius: 1rem 1rem 0 0;
            padding: 1.5rem;
            border: none;
          }

          .btn-dh-primary {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
            border: none;
            color: white;
            border-radius: 8px;
            padding: 8px 16px;
            font-weight: 600;
            transition: all 0.3s ease;
          }

          .btn-dh-primary:hover {
            background: linear-gradient(135deg, #38ef7d 0%, #2dd4bf 100%);
            transform: translateY(-2px);
            color: white;
          }

          .btn-dh-danger {
            background: linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%);
            border: none;
            color: white;
            border-radius: 8px;
            padding: 8px 16px;
            font-weight: 600;
            transition: all 0.3s ease;
          }

          .btn-dh-danger:hover {
            background: linear-gradient(135deg, #ff4b2b 0%, #dc2626 100%);
            transform: translateY(-2px);
            color: white;
          }

          .table-dh {
            border-collapse: separate;
            border-spacing: 0;
            background: white;
            border-radius: 0.75rem;
            overflow: hidden;
          }

          .table-dh thead th {
            background: #374151;
            color: white;
            font-weight: 700;
            border: none;
            padding: 1rem;
          }

          .table-dh tbody tr {
            transition: all 0.2s ease;
          }

          .table-dh tbody tr:hover {
            background: #f8f9fa;
            transform: translateY(-1px);
          }

          .table-dh tbody td {
            padding: 1rem;
            border: none;
            border-bottom: 1px solid #f3f4f6;
            vertical-align: middle;
          }

          .search-box {
            background: white;
            border: 2px solid #e5e7eb;
            border-radius: 8px;
            transition: all 0.3s ease;
          }

          .search-box:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 0.25rem rgba(102, 126, 234, 0.15);
          }

          .stats-card {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
            border-radius: 12px;
            padding: 1.5rem;
            border: 1px solid #e5e7eb;
          }

          .stats-number {
            font-size: 2rem;
            font-weight: 700;
            color: #667eea;
          }

          .user-info {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .project-info {
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }
        `}
      </style>
      
      <ToastContainer position="bottom-right" />
      
      {/* Estadísticas */}
      <Row className="mb-4">
        <Col md={4}>
          <div className="stats-card text-center">
            <div className="stats-number">{totalAsignaciones}</div>
            <div className="text-muted">Total Asignaciones</div>
          </div>
        </Col>
        <Col md={4}>
          <div className="stats-card text-center">
            <div className="stats-number">{usuariosConProyectos}</div>
            <div className="text-muted">Usuarios Asignados</div>
          </div>
        </Col>
        <Col md={4}>
          <div className="stats-card text-center">
            <div className="stats-number">{proyectosConUsuarios}</div>
            <div className="text-muted">Proyectos Activos</div>
          </div>
        </Col>
      </Row>

      <Card className="card-dh">
        <Card.Header className="card-header-dh">
          <Row className="align-items-center">
            <Col>
              <h4 className="mb-0">Gestión Usuarios - Proyectos</h4>
              <p className="mb-0 opacity-75">Administrar asignaciones de usuarios a proyectos</p>
            </Col>
            <Col xs="auto">
              <Button 
                className="btn-dh-primary d-flex align-items-center gap-2"
                onClick={handleShow}
              >
                <FaPlus /> Nueva Asignación
              </Button>
            </Col>
          </Row>
        </Card.Header>
        
        <Card.Body className="p-4">
          <Row className="mb-4">
            <Col md={8}>
              <InputGroup>
                <InputGroup.Text>
                  <FaSearch />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Buscar por usuario, email, proyecto..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="search-box"
                />
              </InputGroup>
            </Col>
          </Row>

          {loading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Cargando...</span>
              </div>
            </div>
          ) : (
            <Table responsive className="table-dh">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Usuario</th>
                  <th>Email</th>
                  <th>Documento</th>
                  <th>Proyecto</th>
                  <th>Ubicación</th>
                  <th>Fecha Asignación</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {filteredAsignaciones.length > 0 ? (
                  filteredAsignaciones.map((asignacion) => (
                    <tr key={asignacion.id}>
                      <td>
                        <Badge bg="secondary">{asignacion.id}</Badge>
                      </td>
                      <td>
                        <div className="user-info">
                          <FaUserTie className="text-primary" />
                          <span className="fw-semibold">{asignacion.usuario_nombre}</span>
                        </div>
                      </td>
                      <td className="text-muted">{asignacion.usuario_email}</td>
                      <td>
                        <Badge bg="info">{asignacion.usuario_documento}</Badge>
                      </td>
                      <td>
                        <div className="project-info">
                          <FaBuilding className="text-success" />
                          <span className="fw-semibold">{asignacion.proyecto_nombre}</span>
                        </div>
                      </td>
                      <td className="text-muted">
                        <small>
                          {asignacion.proyecto_pais}, {asignacion.proyecto_provincia}, {asignacion.proyecto_distrito}
                        </small>
                      </td>
                      <td>{new Date(asignacion.created_at).toLocaleDateString('es')}</td>
                      <td>
                        <Button
                          size="sm"
                          className="btn-dh-danger"
                          onClick={() => handleDelete(asignacion.id)}
                          title="Eliminar asignación"
                        >
                          <FaTrash />
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center py-4 text-muted">
                      {searchTerm ? 'No se encontraron asignaciones que coincidan con la búsqueda' : 'No hay asignaciones registradas'}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>

      {/* Modal para crear asignación */}
      <Modal show={showModal} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
          <Modal.Title>Nueva Asignación Usuario - Proyecto</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="d-flex align-items-center gap-2">
                    <FaUser /> Usuario <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    name="id_user"
                    value={currentAssignment.id_user}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Seleccione un usuario</option>
                    {usuarios.map((usuario) => (
                      <option key={usuario.id} value={usuario.id}>
                        {usuario.nombre} - {usuario.email}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label className="d-flex align-items-center gap-2">
                    <FaProjectDiagram /> Proyecto <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    name="id_proyecto"
                    value={currentAssignment.id_proyecto}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Seleccione un proyecto</option>
                    {proyectos.map((proyecto) => (
                      <option key={proyecto.id} value={proyecto.id}>
                        {proyecto.nombre} ({proyecto.pais})
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            {currentAssignment.id_user && currentAssignment.id_proyecto && (
              <Alert variant="info" className="mt-3">
                <strong>Nueva asignación:</strong><br />
                <FaUser className="me-2" />
                {usuarios.find(u => u.id === parseInt(currentAssignment.id_user))?.nombre}
                <br />
                <FaProjectDiagram className="me-2" />
                {proyectos.find(p => p.id === parseInt(currentAssignment.id_proyecto))?.nombre}
              </Alert>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button 
            className="btn-dh-primary" 
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Creando...' : 'Crear Asignación'}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default MantenimientoUsuariosProyectos;